import { Checkbox } from "@vds/checkboxes";
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { Button, Modal, Select, Switch } from "antd";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { fetchUserEndPoint } from "../../configuration";
import { Box } from "@mui/material";
import {
  createUserList,
  updateUserList,
  fetchOrganization,
  fetchRoles,
} from "../../global/utility/Utils";
// import { DeleteUserModal } from "../UserModal";
import { getRandomUUID } from "../../Token";
// import { deleteUserEndPoint } from "../../../configuration";
import ValidationIcon, {
  getInputClassNames,
  getInputClassNamesUser,
  ErrorMessage,
} from "../../global/components/ValidationIcon";
import ToastNotification from "../../global/components/ToastNotification";
import { Description } from "@mui/icons-material";
import { BarcodeOutlined } from "@ant-design/icons";
import { Input } from "antd";
const { Option } = Select;
const optionStyles = {
  padding: "10px",
  width: "100%",
  borderBottom: "1px solid #D8DADA",
};
const dropdownStyles = {
  border: "1px solid #D8DADA",
  borderRadius: "10px",
  padding: "5px",
};

const CreateUserModel = ({
  visible,
  onClose,
  onSave,
  state,
  role_id,
  onUserCreated,
}) => {
  let navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
  let smsChecked = false;
  const [deviceType, setDeviceType] = useState("");
  const [showDeleteUser, setShowDeleteUser] = useState(false);
  const [deleteUserConfirmed, setDeleteUserConfirmed] = useState(false);
  const [organizationList, setOrganizationList] = useState([]);
  const [rolesList, setRolesList] = useState([]);
  const [notificationProps, setNotificationProps] = useState({});
  const [showNotification, setShowNotification] = useState(false);
  const [typeNotific, setTypeNotific] = useState("error");
  const [msgNotific, setMsgNotific] = useState("");
  const [sendSMS, setSendSMS] = useState(smsChecked);
  const [formData, setFormData] = useState({
    Name: "",
    description: "",
    deviceType: "",
    isActive: "",
    assestType: "",
  });

  const [errors, setErrors] = useState({
    Name: "initial",
    description: "initial",
    deviceType: "initial",
    isActive: "initial",
    assetType: "initial",
  });
  const locations = useSelector((state) => state.alert.bulkUpdate.locations);
  const filtersFields = useSelector(
    (state) => state.alert.bulkUpdate.filters.fields
  );
  const [dataList, setDataList] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [toggled, setToggled] = useState(false);

  const [isChecked, setIsChecked] = useState(false);

  const handleDeviceTypeChange = (value) => {
    setDeviceType(value);
  };

  const handleToggle = (checked) => {
    setIsChecked(checked);
  };

  const handleChange = async (e) => {
    const { name, value } = e.target ? e.target : e;
    setFormData({ ...formData, [name]: value });

    let tempErrors = { ...errors };
    switch (name) {
      case "Name":
        tempErrors.Name = value ? "" : "Please enter a Name";
        break;
      case "description":
        tempErrors.description = value ? "" : "Please enter a description";
        break;
      case "deviceType":
        tempErrors.deviceType = value ? "" : "Please enter a device type";
        break;
      case "assetType":
        tempErrors.assetType = value ? "" : "Please select a asset type";
        break;
      default:
        break;
    }
    setErrors(tempErrors);
  };
  // const handleSubmit = async () => {
  //   let tempErrors = { ...errors };

  //   // Validate the required fields
  //   tempErrors.Name = formData.Name ? "" : "Please enter a Name";
  //   tempErrors.description = formData.description
  //     ? ""
  //     : "Please enter a description";
  //   tempErrors.deviceType = formData.deviceType
  //     ? ""
  //     : "Please enter a device type";
  //   tempErrors.assetType = formData.assetType
  //     ? ""
  //     : "Please select an asset type";

  //   // If there are validation errors, show an error notification
  //   setErrors(tempErrors);
  //   if (Object.values(tempErrors).some((x) => x !== "")) {
  //     setNotificationProps({
  //       type: "error",
  //       message:
  //         state !== null && state?.createuser == undefined
  //           ? "Edit device"
  //           : "Add device",
  //       description: "Form contains invalid data",
  //       duration: 1,
  //     });
  //     setShowNotification(true);
  //     setTimeout(() => {
  //       setShowNotification(false);
  //     }, 1000);
  //   } else {
  //     if (selectedItem && state?.createuser == undefined) {
  //       // Update user logic if the state is not 'create'
  //       const response = await updateUserList({ ...formData });
  //       if (response?.status === 200 || response?.status === 204) {
  //         setNotificationProps({
  //           type: "success",
  //           message: "Device saved successfully",
  //           description: `Device "${response.data.Name}" updated successfully.`,
  //           duration: 3,
  //         });
  //         setShowNotification(true);
  //         setTimeout(() => {
  //           setShowNotification(false);
  //           onUserCreated(); // Notify parent component (if necessary)
  //         }, 3000);
  //       } else {
  //         setNotificationProps({
  //           type: "error",
  //           message: "Failed to save device",
  //           description:
  //             response?.error_description ||
  //             "An error occurred while updating.",
  //           duration: 3,
  //         });
  //         setShowNotification(true);
  //         setTimeout(() => {
  //           setShowNotification(false);
  //         }, 3000);
  //       }
  //     } else {
  //       // Add new device logic
  //       const newItem = { id: Date.now(), ...formData };
  //       const response = await createUserList(newItem, sendSMS);
  //       setDataList([...dataList, newItem]);

  //       if (response?.status === 200 || response?.status === 204) {
  //         setFormData({
  //           Name: "",
  //           description: "",
  //           deviceType: "",
  //           isActive: "",
  //           assetType: "",
  //         });

  //         setNotificationProps({
  //           type: "success",
  //           message: "Device added successfully",
  //           description: `Device "${response.data.Name}" created successfully.`,
  //           duration: 3,
  //         });
  //         setShowNotification(true);
  //         setTimeout(() => {
  //           onUserCreated(); // Notify parent component (if necessary)
  //           setShowNotification(false);
  //         }, 3000);
  //       } else {
  //         setNotificationProps({
  //           type: "error",
  //           message: "Failed to add device",
  //           description:
  //             response?.error_description || "An error occurred while adding.",
  //           duration: 3,
  //         });
  //         setShowNotification(true);
  //         setTimeout(() => {
  //           setShowNotification(false);
  //         }, 3000);
  //       }
  //     }
  //   }
  // };
  // const cancleModel = () => {
  //   onClose();
  // };
  useEffect(() => {}, [showNotification, notificationProps]);
  useEffect(() => {
    const getData = async () => {
      try {
        const data = await fetchOrganization();

        if (data.length > 0) {
          setOrganizationList(
            data.filter(
              (d) =>
                d?.tags &&
                d?.tags.length > 0 &&
                d?.tags[0]?.kind === "ts.tag.org"
            )
          );
        }
      } catch (error) {}
    };
    const getRole = async () => {
      try {
        const data = await fetchRoles();
        let roles = [];
        if (user?.role?.name !== "SUPER_ADMIN") {
          roles = data?.filter((d) => d.name !== "SUPER_ADMIN");
        } else {
          roles = data;
        }
        setRolesList(roles);
      } catch (error) {
        console.log(error);
      }
    };
    getData();
    getRole();
  }, []);

  useEffect(() => {
    if (state) {
      if (user?.role?.permissions?.users?.edit) {
        if (state.hasOwnProperty("org_id")) {
          setSelectedItem({
            organization: state?.org_id,
          });
          setFormData({
            organization: state?.org_id,
          });
        } else {
          setSelectedItem({
            firstName: state?.firstname,
            lastName: state?.lastname,
            email: state?.email,
            mobileNumber: state?.mdn,
            role: state?.customdata?.roleId,
            organization: state?.customdata?.orgId,
            oldroleid: state?.customdata?.roleId,
          });
          setFormData({
            firstName: state?.firstname,
            lastName: state?.lastname,
            email: state?.email,
            mobileNumber: state?.mdn,
            role: state?.customdata?.roleId,
            organization: state?.customdata?.orgId,
            oldroleid: state?.customdata?.roleId,
            id: state?.id,
          });
        }
      } else if (!user?.role?.permissions?.users?.create) {
        navigate("/users");
      }
    } else if (!user?.role?.permissions?.users?.create) {
      navigate("/users");
    }
  }, [state, user, navigate]);

  return (
    <Modal open={visible} onCancel={onClose} footer={null} width={600}>
      <Box bulkalert-modal-content>
        <>
          {showNotification && (
            <ToastNotification
              type={notificationProps.type}
              message={notificationProps.message}
              description={notificationProps.description}
              duration={notificationProps.duration}
              style={notificationProps.style}
            />
          )}
          <div style={{ marginBottom: "10px" }}>
            <h2 className={"font-face-vzb page-heading-user"}>Edit Device</h2>
            <br />
            <h4 className={"font-face-vzb page-sub-heading-user"}>
              Information
            </h4>
          </div>
          <>
            <Grid2
              container
              marginTop={1}
              marginBottom={2}
              spacing={1}
              columns={{ xs: 12 }}
            >
              <Grid2 item xs={12}>
                {/* <div className="mb-3"> */}
                <label htmlFor="firstName" className="input-label-user">
                  Name
                </label>
                <div className="input-container">
                  {/* <input
                                        type="text"
                                        id="Name"
                                        name="Name"
                                        value={formData.Name}
                                        onChange={handleChange}
                                        className={getInputClassNamesUser("Name", formData, errors)}
                                        style={{ boxShadow: "none" }}
                                    /> */}
                  <Input
                    className="alert-box-size"
                    value={filtersFields.name}
                    onChange={handleChange}
                    suffix={
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          paddingLeft: "10px",
                          borderLeft: "1px solid #e0dcdc",
                          height: "130%",
                        }}
                      >
                        <BarcodeOutlined
                          style={{
                            fontSize: "20px",
                            color: "#111111",
                            cursor: "pointer",
                          }}
                        />
                      </div>
                    }
                  />
                  <ValidationIcon
                    fieldName="Name"
                    formData={formData}
                    errors={errors}
                    color={"blue"}
                  />
                  <p
                    style={{
                      marginTop: "5px",
                      color: "#6F7171",
                      fontSize: "12px",
                      marginBottom: "8px",
                    }}
                  >
                    Type a name or click the button to scan a QR or bar code.
                  </p>
                </div>
                <div style={{ paddingTop: 5 }}>
                  <ErrorMessage fieldName="Name" errors={errors} />
                </div>
                {/* </div> */}
              </Grid2>

              <Grid2 item xs={12}>
                <div className="mb-3">
                  <label htmlFor="lastName" className="input-label-user">
                    Description/Notes
                  </label>
                  <div className="input-container">
                    {/* <input
                      id="description"
                      name="description"
                      value={formData.description}
                      onChange={handleChange}
                      className={getInputClassNamesUser(
                        "description",
                        formData,
                        errors
                      )}
                      style={{ boxShadow: "none" }}
                    /> */}
                    <Input
                      className="alert-box-size"
                      value={filtersFields.description}
                      onChange={handleChange}
                    />
                    <ValidationIcon
                      fieldName="description"
                      formData={formData}
                      errors={errors}
                    />
                  </div>
                  <div style={{ paddingTop: 5 }}>
                    <ErrorMessage fieldName="description" errors={errors} />
                  </div>
                </div>
              </Grid2>
              <h4 className={"font-face-vzb page-sub-heading-user"}>
                Configuration
              </h4>
              <Grid2 item xs={12}>
                {/* <div className="mb-3"> */}
                <label htmlFor="devicetype" className="input-label-user">
                  Device Model
                </label>
                <div className="input-container">
                  <Select
                    placeholder=""
                    style={{ width: "100%" }}
                    allowClear
                    size="large"
                    value={filtersFields.deviceType}
                    onChange={handleDeviceTypeChange} // Update deviceType when dropdown changes
                  >
                    <Option value="ts.device.tgAssetTracker">Gateway</Option>
                    <Option value="ts.device.ble">BLE Tag</Option>
                  </Select>
                  <ValidationIcon
                    fieldName="deviceType"
                    formData={formData}
                    errors={errors}
                  />
                </div>
                <div style={{ paddingTop: 5 }}>
                  <ErrorMessage fieldName="deviceType" errors={errors} />
                </div>
                <p
                  style={{
                    color: "#6F7171",
                    fontSize: "12px",
                    marginBottom: "8px",
                  }}
                >
                  Device model cannot be changed for existing devices.
                </p>
                {/* </div> */}
              </Grid2>

              <Grid2 item xs={12}>
                <div className="mb-3">
                  <label htmlFor="role" className="input-label-user">
                    Asset Type
                  </label>
                  <div className="input-container">
                    <Select
                      placeholder=""
                      style={{ width: "100%" }}
                      allowClear
                      size="large"
                      //   enabled={
                      //     deviceInfo.deviceType !== "ts.device.tgAssetTracker"
                      //   }
                      // onChange={(value) =>
                      //   handleInputChange("gatewayType", value)
                      // }
                    >
                      <Option value="BIN">BIN</Option>
                      <Option value="CAN">CAN</Option>
                      <Option value="HOSE">HOSE</Option>
                      <Option value="POD">POD</Option>
                    </Select>
                    {/* <Select
                      id="assetType"
                      style={{ width: "100%", height: "50px" }}
                      name="assetType"
                      value={formData.assetType}
                      dropdownStyle={dropdownStyles}
                      onChange={(value) =>
                        handleChange({ name: "assetType", value: value })
                      }
                      // className={getInputClassNamesUser("organization", formData, errors)}
                      aria-label=".form-select-lg example"
                    >
                      <option style={optionStyles} value="">
                        Select Asset Type
                      </option>
                      <option value="Mobile">Mobile Gateway</option>
                      <option value="Fixed">Fixed Gateway</option>
                    </Select> */}
                    <ValidationIcon
                      fieldName="assetType"
                      formData={formData}
                      errors={errors}
                    />
                  </div>
                  <div style={{ paddingTop: 5 }}>
                    <ErrorMessage fieldName="assetType" errors={errors} />
                  </div>
                  {deviceType === "ts.device.ble" && (
                    <p
                      style={{
                        color: "#6F7171",
                        fontSize: "12px",
                      }}
                    >
                      Applies to BLE TAGS only.
                    </p>
                  )}
                </div>
              </Grid2>

              {/* <Grid2 item xs={12}>
                <Switch
                  checked={isChecked}
                  onChange={handleToggle}
                  style={{
                    backgroundColor: isChecked ? "#008331" : "", // Green for ON, Red for OFF
                  }}
                />
              </Grid2> */}
              {/* <Grid2 item xs={12}>
              <div className="mb-3">
                <label htmlFor="twofactor" className="input-label-user">
                  Require two factor authentication
                </label>
                <div className="input-container">
                  <select
                    id="twofactor"
                    style={{ appearance: "auto", boxShadow: "none" }}
                    disabled
                    name="twofactor"
                    value={formData.twofactor}
                    onChange={handleChange}
                    className="form-control login-form-control"
                    aria-label=".form-select-lg example"
                  >
                    <option value="1">NO</option>
                    <option value="2">YES</option>
                  </select>
                  {errors.twofactor && <p className="custom-error-message">{errors.twofactor}</p>}
                </div>
                {errors.twofactor && <i className="bi bi-exclamation-diamond input-icon-failure"></i>}
                <p class="light-grey-text-color">
                  Forces user to enter code sent via email/SMS to login. Does not apply to SSO users.
                </p>
              </div>
            </Grid2> */}
              {deviceType === "ts.device.ble" && (
                <Grid2 item xs={12} container alignItems="center" spacing={1}>
                  <Grid2 item>
                    <Switch checked={isChecked} onChange={handleToggle} />
                  </Grid2>
                  <Grid2 item>
                    <p
                      style={{
                        fontSize: "13px",
                        marginBottom: "1px",
                        marginLeft: "10px",
                      }}
                    >
                      Activate Device
                    </p>
                  </Grid2>
                </Grid2>
              )}
            </Grid2>

            {state === null || state?.createuser === true ? (
              <Checkbox
                selected={sendSMS}
                onChange={(e) => {
                  setSendSMS(!sendSMS);
                }}
              >
                Send Welcome email to the new user?
              </Checkbox>
            ) : (
              ""
            )}
            <Grid2
              container
              marginTop={1}
              marginBottom={2}
              spacing={1}
              columns={{ xs: 12 }}
            >
              <Grid2 item xs={12} sm={6} md={6} lg={6}>
                <div className="mb-3">
                  <Button
                    className="custom-button-cancel"
                    type="default"
                    //onClick={cancleModel}
                    onClick={onClose}
                    shape="round"
                    style={{ fontWeight: "bold", width: "100%" }}
                    size={"large"}
                  >
                    Cancel
                  </Button>
                </div>
              </Grid2>

              <Grid2 item xs={12} sm={6} md={6} lg={6}>
                <div className="mb-3">
                  <Button
                    className="custom-button-save"
                    type="primary"
                    //onClick={handleSubmit}
                    shape="round"
                    style={{
                      width: "100%",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold",
                    }}
                    size={"large"}
                  >
                    {state !== null && state?.createuser == undefined
                      ? "Save"
                      : "Add"}
                  </Button>
                </div>
              </Grid2>
            </Grid2>
            <br />
          </>
        </>
      </Box>
    </Modal>
  );
};

export default CreateUserModel;
